
import { PROFILES } from 'CONST';

// archivo con los permisos de lectura/escritura

export const GARANTIA_WRITE = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.gerenteRiesgoGarantia,
  PROFILES.analistaRiesgoGarantia,
];

export const GARANTIA_READ = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.comercialGarantia,
  PROFILES.gerenteGarantia,
  PROFILES.suscripcionGarantia,
  PROFILES.gerenteRiesgoGarantia,
  PROFILES.analistaRiesgoGarantia,
  PROFILES.actuariado,
  PROFILES.gerenteOperaciones,
  PROFILES.analistaOperaciones,
  PROFILES.riesgoOperacional,
  PROFILES.siniestros,
];

export const GARANTIA_EDIT_WRITE = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.gerenteRiesgoGarantia,
  PROFILES.analistaRiesgoGarantia,
  PROFILES.actuariado,
];

export const GARANTIA_EXPOSICION_MAXIMA_WRITE = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.gerenteRiesgoGarantia,
  PROFILES.actuariado,
  PROFILES.analistaRiesgoGarantia,
];

export const GARANTIA_EDIT_READ = [
	PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.comercialGarantia,
  PROFILES.gerenteGarantia,
  PROFILES.suscripcionGarantia,
  PROFILES.gerenteRiesgoGarantia,
  PROFILES.analistaRiesgoGarantia,
  PROFILES.actuariado,
  PROFILES.gerenteOperaciones,
  PROFILES.analistaOperaciones,
  PROFILES.riesgoOperacional,
  PROFILES.siniestros,
];

export const EXPOSICION_MAXIMA_LIMITE_SUPERADO = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.actuariado,
]

export const ALL = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.consultaEspecial,
  PROFILES.comercialGarantia,
  PROFILES.gerenteGarantia,
  PROFILES.suscripcionGarantia,
  PROFILES.gerenteRiesgoGarantia,
  PROFILES.analistaRiesgoGarantia,
  PROFILES.comercialCredito,
  PROFILES.riesgoCredito,
  PROFILES.fiscalia,
  PROFILES.actuariado,
  PROFILES.gerenteOperaciones,
  PROFILES.analistaOperaciones,
  PROFILES.riesgoOperacional,
  PROFILES.siniestros,
  PROFILES.recuperoSiniestros,
  PROFILES.consultaBasico,
  PROFILES.administrador,
];